module.exports = __webpack_public_path__ + "static/img/emiel.2752c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/emiel.png
// module id = yiRT
// module chunks = 0